import { defineStore } from 'pinia'

import { VBreadcrumbItem } from '@/@types/vuetify'

const useBreadcrumbsStore = defineStore('breadcrumbs', {
    state: () => ({
        breadcrumbs: [] as Array<VBreadcrumbItem>
    }),
    actions: {
        set (breadcrumbs: Array<VBreadcrumbItem>): void {
            this.breadcrumbs = breadcrumbs
        },
        reset (): void {
            this.breadcrumbs = []
        }
    }
})

export {
    useBreadcrumbsStore
}
